module.exports = __webpack_public_path__ + "img/calendar.509ab80.jpg";